import React, { FC } from "react";

import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Text } from "@bookingcom/bui-react";
import { UIFlightSegment, UIIncludedProductSegment } from "@flights/types";

import { BaggageItem } from "./BaggageItem";
import styles from "./BaggageSegment.module.css";
import flights_web_remove_baggage_weight_size_fd from "../../../../utils/experiments/funnel/flights_web_remove_baggage_weight_size_fd";

export const BaggageSegment: FC<{
  flightSegment: UIFlightSegment;
  baggageSegment: UIIncludedProductSegment;
  showHeader?: boolean;
  hideIncludedSection?: boolean;
  /* start - flights_web_remove_baggage_weight_size_fd */
  showRestrictions?: boolean;
  /* end - flights_web_remove_baggage_weight_size_fd */
}> = ({ flightSegment, baggageSegment, showHeader, hideIncludedSection, showRestrictions }) => {
  return (
    <div>
      {showHeader && <Header flightSegment={flightSegment} />}
      <BaggageSegmentList
        hideIncludedSection={hideIncludedSection}
        baggageSegment={baggageSegment}
        showRestrictions={showRestrictions}
      />
    </div>
  );
};

const Header: FC<{ flightSegment: UIFlightSegment }> = ({ flightSegment }) => {
  const i18n = useI18n();
  const { arrivalAirport } = flightSegment;

  return (
    <Text
      variant={flights_web_remove_baggage_weight_size_fd.trackWithDefaultStage() ? "strong_2" : "strong_1"}
      className={styles.header}
    >
      {i18n.trans(
        t("flights_details_route", {
          variables: {
            city_name: arrivalAirport.cityName || arrivalAirport.name
          }
        })
      )}
    </Text>
  );
};

const BaggageSegmentList: FC<{
  baggageSegment: UIIncludedProductSegment;
  hideIncludedSection?: boolean;
  /* start - flights_web_remove_baggage_weight_size_fd */
  showRestrictions?: boolean;
  /* end - flights_web_remove_baggage_weight_size_fd */
}> = ({ baggageSegment, hideIncludedSection, showRestrictions }) => {
  return (
    <>
      {baggageSegment.map((item, i) => {
        return (
          <div className={styles.listItem} key={`${item.luggageType}-${i}`}>
            <BaggageItem luggage={item} hideIncludedSection={hideIncludedSection} showRestrictions={showRestrictions} />
          </div>
        );
      })}
    </>
  );
};
